import { render } from "./DrawerCard.vue?vue&type=template&id=0d57d5bc&scoped=true"
import script from "./DrawerCard.vue?vue&type=script&lang=js"
export * from "./DrawerCard.vue?vue&type=script&lang=js"

import "./DrawerCard.vue?vue&type=style&index=0&id=0d57d5bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d57d5bc"]])

export default __exports__